import { useAutoAnimate } from '@formkit/auto-animate/react';
import { useAnimations } from '@/stores/animations';
import type {
  AutoAnimateOptions,
  AutoAnimationPlugin,
} from '@formkit/auto-animate';

/**
 * A wrapper around useAutoAnimate that respects the user's animation preferences.
 * When animations are disabled, this hook returns a ref without any animation behavior.
 */
export const useAutoAnimateConditional = <T extends Element = Element>(
  options?: Partial<AutoAnimateOptions> | AutoAnimationPlugin,
): [React.RefCallback<T>, (enabled: boolean) => void] => {
  const { enabled } = useAnimations();

  // Call useAutoAnimate unconditionally to follow React hooks rules
  const [ref, enable] = useAutoAnimate<T>(options);

  // Enable/disable the animations based on the global setting
  if (typeof enable === 'function') {
    enable(enabled);
  }

  // Always return the ref since useAutoAnimate handles the enabling/disabling internally
  return [ref, enable];
};
